import './Pages.css';
import '../css/navbarchap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useEffect} from "react";
import PDFViewerComponent from '../components/PDFViewerComponent';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const Chapitre4sc3partE = () => {
   
    useEffect(() => {
        document.body.classList.add('no-scroll'); // Ajoutez la classe no-scroll au body
        return () => {
          document.body.classList.remove('no-scroll'); // Retirez la classe no-scroll du body lorsque le composant est démonté
        };
      }, []);

const navigate = useNavigate();

    return (
      <div className="Chapitre">
        <Navbar expand="lg">
            <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav">
                <span className='navbar-toggler-nav'></span>
            </Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mx-auto">
                  <Nav.Link href="" className={ 'navbar-link'} onClick={() => navigate('/chapitre4sc3partd')}>Chapitre précédent
                    <div className="small-italic">D.  Reportages sur la montagne,<br/>Gurs, crimes de l'ogresse</div>
                  </Nav.Link>
                  <Nav.Link href="#sommaire" className={  'navbar-link'} onClick={() => navigate('/')}>Retour au sommaire
                    <div className="small-italic">E.  1940 à 1943: un éditorialiste<br/>"empêché"</div>
                  </Nav.Link>
                  <Nav.Link href="" className={'navbar-link'} onClick={() => navigate('/chapitre4sc3partf')}>Chapitre suivant
                    <div className="small-italic">F.  Un récit de "L'indépendant<br/>des Pyrénées</div>
                  </Nav.Link>
                </Nav>
            </Navbar.Collapse>
            </Container>
        </Navbar>
          <div className="PDF-viewer-container">
			      <PDFViewerComponent
				      document={`${process.env.PUBLIC_URL}chapitre4sc3parte.pdf`}
			      />
		    </div>
      </div>
    );
  };
export default Chapitre4sc3partE;
  

